import { Component, Prop, toNative, Vue } from '@natureos/vue-facing-decorator';

@Component({ name: 'Button' })
class Button extends Vue {
  @Prop({
    type: String,
    default: 'primary',
    validator: (value: string) =>
      ['primary', 'secondary', 'white', 'danger', 'outline', 'menu', 'ghost'].includes(value),
  })
  public readonly variant!: string;

  @Prop({
    type: String,
    default: 'md',
    validator: (value: string) => ['sm', 'md', 'lg'].includes(value),
  })
  public readonly size!: string;

  @Prop({ type: Boolean, default: false })
  public readonly isLoading!: boolean;

  @Prop({ type: Boolean, default: false })
  public readonly isDisabled!: boolean;

  @Prop({ type: String, default: 'button' })
  public readonly type!: 'button' | 'submit' | 'reset' | undefined;

  public get buttonClasses(): string {
    const baseClasses =
      'inline-flex items-center justify-center rounded-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-1';

    const variantClasses: Record<string, string> = {
      primary: 'bg-brand text-white hover:bg-brand-400',
      secondary: 'bg-gray-600 text-white hover:bg-gray-700',
      white: 'bg-white text-black hover:bg-gray-100',
      danger: 'bg-red-600 text-white hover:bg-red-700',
      outline: 'border border-gray-300 text-gray-700 hover:bg-gray-50',
      ghost: 'border-0 bg-transparent text-gray-700 hover:bg-gray-50',
      menu: 'rounded-md bg-black/20 px-4 py-2 hover:bg-black/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75',
    };

    const sizeClasses: Record<string, string> = {
      sm: 'px-3 py-1.5 text-sm',
      md: 'px-4 py-2 text-base',
      lg: 'px-6 py-3 text-lg',
    };

    const isDisabledClasses = this.isDisabled ? 'opacity-50 cursor-not-allowed' : '';
    const isLoadingClasses = this.isLoading ? '' : 'cursor-pointer';

    return [
      baseClasses,
      variantClasses[this.variant],
      sizeClasses[this.size],
      isDisabledClasses,
      isLoadingClasses,
    ].join(' ');
  }
}

export default toNative(Button);
export { default as Button } from './button.component.vue';
